import { render, staticRenderFns } from "./TvDashboardTabs.vue?vue&type=template&id=73686e2f&"
import script from "./TvDashboardTabs.vue?vue&type=script&lang=js&"
export * from "./TvDashboardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports